export const registrationSuccessRoute = (token: string | null) =>
  token ? '/dashboard/home' : '/';
